import { z } from 'zod';
import { BookingType } from '../../bookings/Booking.js';
import { QuickActionId } from './quick-action-id.js';

/**
 * An `ActionTarget` is the payload that describes what happens when a widget
 * surface is activated. `ActionLink` (dealer-authored, stored on the services
 * provider doc) and `Nudge` (Ekho-authored, resolved server-side) are two
 * containers that each carry one, differing in who authors them, how they
 * reach the widget, and what triggers them—the payload itself is identical.
 * Extracting the union is what lets one client dispatcher serve both surfaces.
 */
const promptActionTargetSchema = z.object({
    kind: z.literal('prompt'),
    /** Message the widget sends as if the buyer typed it. */
    text: z.string().min(1),
});
const formActionTargetSchema = z.object({
    kind: z.literal('form'),
    /**
     * Which quick-action form the click opens. Drawn from `QuickActionId` so a
     * seeded string is guaranteed to map to a real registered flow.
     */
    quickActionId: z.nativeEnum(QuickActionId),
    /**
     * Only meaningful when `quickActionId` is `book_appointment`—the appointment
     * variant the form opens in. Ignored for every other quick action.
     */
    bookingType: z.nativeEnum(BookingType).optional(),
});
const actionTargetSchema = z.discriminatedUnion('kind', [
    promptActionTargetSchema,
    formActionTargetSchema,
]);
/** Closed set of action-target kinds; stamped onto analytics events. */
const actionTargetKindSchema = z.enum(['prompt', 'form']);

export { actionTargetKindSchema, actionTargetSchema };
//# sourceMappingURL=action-target.js.map
